module.exports = __webpack_public_path__ + "static/media/Penn Frame Red.c4aaac88.png";